import { PlaybackContainer } from "@/features/deployment-dashboard";

export function PlaybackRoute() {
  return <PlaybackContainer />;
}
